<div class="modal-header">
    <h6 class="modal-title">Profile</h6>
    <button type="button" class="btn btn-icon btn-sm btn-active-light-primary ms-2" 
            (click)="activeModal.dismiss('Cross click')">
        <i class="ki-outline ki-cross fs-1"></i>
    </button>
</div>
<div class="modal-body">
    <!--begin::Loading State-->
    <div class="d-flex flex-column align-items-center justify-content-center py-15" *ngIf="isLoading">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="text-gray-600 fs-6 mt-4">Loading profile...</p>
    </div>
    <!--end::Loading State-->

    <!--begin::Error State-->
    <div class="d-flex flex-column align-items-center justify-content-center py-15" *ngIf="!isLoading && hasError">
        <i class="ki-outline ki-information-2 fs-3x text-warning mb-5"></i>
        <h4 class="text-gray-800 fw-bold mb-2">Profile Not Available</h4>
        <p class="text-gray-600 fs-6 mb-0">This profile could not be loaded. Please try again later.</p>
    </div>
    <!--end::Error State-->

    <!--begin::Profile Content-->
    <div class="app-main flex-column flex-row-fluid" id="kt_app_main" *ngIf="!isLoading && !hasError">
        <div class="d-flex flex-wrap flex-sm-nowrap" *ngIf="profileData">
            <!--begin: Pic-->
            <div class="me-7 mb-4">
                <div class="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                    <img src="./assets/media/avatars/blank.png" *ngIf="!profileData?.profileImage || profileData?.profileImage == ''"
                        aria-hidden="true">
                    <img alt="User Avatar" class="" *ngIf="profileData?.profileImage && profileData?.profileImage != ''"
                        [src]="profileData?.profileImage" alt="">
                    <div
                        class="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-body h-20px w-20px">
                    </div>
                </div>
            </div>
            <!--end::Pic-->
            <!--begin::Info-->
            <div class="flex-grow-1">
                <!--begin::Title-->
                <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
                    <!--begin::User-->
                    <div class="d-flex flex-column">
                        <!--begin::Name-->
                        <div class="d-flex align-items-center mb-2">
                            <a href="javascript:void(0)"
                                class="text-gray-900 text-hover-primary fs-2 fw-bold me-1">{{getProfileByUserData?.displayName || profileData?.userName}}</a>
                            <a href="javascript:void(0)">
                                <i class="ki-duotone ki-verify fs-1 text-primary">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                </i>
                            </a>
                        </div>
                        <!--end::Name-->
                        <!--begin::Info-->
                        <div class="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2">
                            <div class="d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
                                title="Qualification" *ngIf="getUserSkillsGoalsData?.qualification">
                                <i class="ki-duotone ki-profile-circle fs-4 me-1">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                    <span class="path3"></span>
                                </i>
                                <span ngbTooltip="{{getUserSkillsGoalsData?.qualification}}">
                                    {{getUserSkillsGoalsData?.qualification | slice:0:19}}<span
                                        *ngIf="getUserSkillsGoalsData?.qualification?.length > 19">...</span>
                                </span>
                            </div>
                            <div class="d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
                                title="country" *ngIf="getUserSkillsGoalsData?.showMyDetails == true && getProfileByUserData?.country">
                                <i class="ki-duotone ki-geolocation fs-4 me-1">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                </i>
                                {{getProfileByUserData?.country}}
                            </div>
                            <div class="d-flex align-items-center text-gray-500 text-hover-primary mb-2" title="Email"
                                *ngIf="getUserSkillsGoalsData?.showMyEmail == true && getProfileByUserData?.email">
                                <i class="ki-duotone ki-sms fs-4 me-1">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                </i>
                                {{getProfileByUserData?.email}}
                            </div>
                        </div>
                        <!--end::Info-->
                    </div>
                    <!--end::User-->
                </div>
                <!--end::Title-->
                <!--begin::Stats-->
                <div class="d-flex flex-wrap flex-stack">
                    <!--begin::Wrapper-->
                    <div class="d-flex flex-column flex-grow-1 pe-8">
                        <!--begin::Stats-->
                        <div class="d-flex flex-wrap">
                            <!--begin::Stat-->
                            <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
                                *ngIf="getUserSkillsGoalsData?.showMyDetails == true">
                                <!--begin::Number-->
                                <div class="d-flex align-items-center">
                                    <i class="las la-star fs-3 text-warning me-1" title="Rating">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                    </i>
                                    <div class="fs-2 fw-bold">
                                        {{getUserSkillsGoalsData?.review_Rating}}
                                    </div>
                                </div>
                                <!--end::Number-->
                                <!--begin::Label-->
                                <div class="fw-semibold fs-6 text-gray-500">Rating</div>
                                <!--end::Label-->
                            </div>
                            <!--end::Stat-->
                            <!--begin::Stat-->
                            <div class="border border-gray-300 border-dashed rounded min-w-300px py-3 px-4 me-6 mb-3">
                                <!--begin::Number-->
                                <div class="d-flex align-items-center mb-2">
                                    <i class="las la-id-card fs-3 me-1" title="Summary">
                                        <span class="path1"></span>
                                        <span class="path2"></span>
                                    </i>
                                    <div class="fs-5 fw-bold" ngbTooltip="{{getUserSkillsGoalsData?.profileHeading}}">
                                        {{getUserSkillsGoalsData?.profileHeading |
                                        slice:0:29}}<span
                                            *ngIf="getUserSkillsGoalsData?.profileHeading?.length >= 29">...</span>
                                    </div>
                                    <div class="fs-5 fw-semibold text-gray-600"
                                        *ngIf="getUserSkillsGoalsData?.profileHeading?.length == 0">
                                        No data available
                                    </div>
                                </div>
                                <!--end::Number-->
                                <!--begin::Label-->
                                <div class="fw-semibold fs-6 text-gray-500">Profile Heading</div>
                                <!--end::Label-->
                            </div>
                            <!--end::Stat-->
                        </div>
                        <!--end::Stats-->
                    </div>
                    <!--end::Wrapper-->
                </div>
                <!--end::Stats-->
            </div>
            <!--end::Info-->
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-light-danger btn-sm"
        (click)="activeModal.dismiss('Cross click')">Close</button>
</div>